module.exports = __webpack_public_path__ + "img/virtual_on.4b285d23.svg";